import z from "zod";

export function closedEnum<T extends string>(
  values: Record<string, T>,
  labels: Record<T, string>,
): z.ZodEnum<Record<string, T>> {
  const legend = Object.values(values)
    .filter((value) => labels[value] !== "")
    .map((value) => `${value} = ${labels[value]}`)
    .join(", ");

  return z.enum(values).describe(`One of: ${legend}`);
}
